import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./marcheClimaStore"
import Actions from "./marcheClimaActions"

export let withMarcheCaldaie = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());